$shm_hitalama_vk_posts $mol_ghost
	token_str \
	owner_id \
	posts_data? null
	dto null $shm_hitalama_vk_posts_dto
	collect null
	pending? false
	post_id* \
	post_date* \
	post_likes* \
	post_reposts* \
	post_comments* \
	post_views* \
